export default __webpack_public_path__ + "assets/bf91cbb0a8890f791877c30804d22033.svg";